import { ToppingDictionary } from '../interfaces/Topping';

export enum ToppingIds {
  INSURANCE = 'insurance',
  REFUELING = 'refueling',
  REPLACEMENT_VEHICLE = 'replacement_vehicle',
  WASH = 'wash',
  SPECIALIZED_CENTER_WASH = 'specialized-center-wash',
  INTERIOR_CAR_WASH_TOPPING = 'interior-car-wash-topping',
  EXTERIOR_CAR_WASH_TOPPING = 'exterior-car-wash-topping',
  COMPLETE_CAR_WASH_TOPPING = 'complete-car-wash-topping',
  MOTORBIKE_WASH_TOPPING = 'motorbike-wash-topping',
  TUNNEL_WASH = 'tunnel-wash',
  TUNNEL_EXTERIOR_CAR_WASH_TOPPING = 'tunnel-exterior-car-wash-topping',
  CHECKSTATUSVEHICLE = 'checkStatusVehicle',
  TYRES = 'tyres',
  ACCESORY = 'accesory',
  TOW_TRUCK = 'tow_truck',
  SANITIZED_CAR_WASH = 'sanitizedCarWash',
  INTERIOR_EXTERIOR_CAR_WASH = 'interiorExteriorCarWash',
  ELECTRIC_VEHICLE_BATTERY_CHARGING = 'electricVehicleBatteryCharging',
  VEHICLE_BATTERY_CHARGING = 'vehicleBatteryCharging',
  CHECKING_INFLATING_TYRES = 'checkingInflatingTyres',
  SHEET_METAL_PAINT_REPAIR = 'sheetMetalPaintRepair',
  REFUELING_TOPPING = 'refueling-topping'
}



export const myToppingDictionary: ToppingDictionary = {
  'topping-insurance': {
    id: ToppingIds.INSURANCE,
    icon: 'assets/icons/insurance-during-service.svg',
    titleId: 'insurance',
    descriptionId: 'insuranceDescription',
    showStartingFrom: true,
    hasModal: true,
  },
  'topping-refueling': {
    id: ToppingIds.REFUELING,
    icon: 'assets/icons/refuel.svg',
    titleId: 'refueling',
    descriptionId: 'refuelingDescription',
    showStartingFrom: true,
    hasModal: true,
  },
  'topping-replacement-vehicle': {
    id: ToppingIds.REPLACEMENT_VEHICLE,
    icon: 'assets/icons/sustitution-vehicle.svg',
    titleId: 'replacementVehicle',
    descriptionId: 'replacementVehicleDescription',
    showStartingFrom: true,
    hasModal: true,
  },
  'topping-washes': {
    id: ToppingIds.WASH,
    icon: 'assets/icons/lavados-icon.svg',
    titleId: 'wash',
    descriptionId: 'washDescription',
    showStartingFrom: true,
    hasModal: true,
    relatedToppings: {
      'specialized-center-wash': {
        id: ToppingIds.SPECIALIZED_CENTER_WASH,
        icon: 'assets/icons/lavados-icon.svg',
        titleId: 'specialized-center-wash',
        descriptionId: 'specializedCenterWashDescription',
        showStartingFrom: true,
        relatedToppings: {
          'interior-car-wash-topping': {
            id: ToppingIds.INTERIOR_CAR_WASH_TOPPING,
            icon: '../../../../assets/icons/washing-specialist-center-inside.svg',
            titleId: 'interior',
            descriptionId: 'tunnel_car_wash_description_interior',
            showStartingFrom: true,
            order: 1,
          },
          'exterior-car-wash-topping': {
            id: ToppingIds.EXTERIOR_CAR_WASH_TOPPING,
            icon: '../../../../assets/icons/washing-specialist-center-outside.svg',
            titleId: 'exterior',
            descriptionId: 'tunnel_car_wash_description_exterior',
            showStartingFrom: true,
            hasModal: true,
            order: 2,
          },
          'complete-car-wash-topping': {
            id: ToppingIds.COMPLETE_CAR_WASH_TOPPING,
            icon: '../../../../assets/icons/washing-specialist-center-complete.svg',
            titleId: 'complete',
            descriptionId: 'tunnel_car_wash_description_complete',
            showStartingFrom: true,
            hasModal: true,
            order: 3,
          },
          'motorbike-wash-topping': {
            id: ToppingIds.MOTORBIKE_WASH_TOPPING,
            icon: 'assets/icons/center-complete.svg',
            titleId: 'motorbike-wash-topping',
            descriptionId: 'tunnel_complete_car_wash_description',
            showStartingFrom: true,
            hasModal: true,
          },
        },
      },
      'tunnel-wash': {
        id: ToppingIds.TUNNEL_WASH,
        icon: 'assets/icons/lavados-icon.svg',
        titleId: 'tunnel-wash',
        descriptionId: 'handWashDescription',
        showStartingFrom: true,
        relatedToppings: {
          'tunnel-exterior-car-wash-topping': {
            id: ToppingIds.TUNNEL_EXTERIOR_CAR_WASH_TOPPING,
            icon: 'assets/icons/hand-exterior.svg',
            titleId: 'exterior_wash_tunnel',
            descriptionId: 'basic_service_in_gas_station_tunnel',
            showStartingFrom: true,
          },
        },
      },
    },
  },
  'topping-vehicle-data-collection': {
    id: ToppingIds.CHECKSTATUSVEHICLE,
    icon: 'assets/icons/check-status.svg',
    titleId: 'checkStatusVehicle',
    descriptionId: 'checkStatusVehicleDescription',
    showStartingFrom: true,
    hasModal: false,
  },
  'topping-tyres': {
    id: ToppingIds.TYRES,
    icon: 'assets/icons/tyres.svg',
    titleId: 'checkTyres',
    descriptionId: 'checkTyresDescription',
    showStartingFrom: true,
  },
  'topping-accesory': {
    id: ToppingIds.ACCESORY,
    icon: 'assets/icons/cafler-fresh.svg',
    titleId: 'caflerFresh',
    descriptionId: 'caflerFreshDescription',
    showStartingFrom: true,
  },
  'tow-truck-topping': {
    id: ToppingIds.TOW_TRUCK,
    icon: 'assets/icons/tow-truck.svg',
    titleId: 'tow_truck',
    descriptionId: 'tow_truck_description',
    showStartingFrom: false,
  },
  'sanitized-car-wash-topping': {
    id: ToppingIds.SANITIZED_CAR_WASH,
    icon: 'assets/icons/sanitized-car-wash.svg',
    titleId: 'sanitized-car-wash-topping',
    descriptionId: 'sanitized-car-wash-topping-description',
    showStartingFrom: true
  },
  'interior-exterior-car-wash-topping': {
    id: ToppingIds.INTERIOR_EXTERIOR_CAR_WASH,
    icon: 'assets/icons/interior-exterior-clean.svg',
    titleId: 'interior-exterior-car-wash-topping',
    descriptionId: 'interior-exterior-car-wash-topping-description',
    showStartingFrom: true,
  },
  'electric-vehicle-battery-charging-topping': {
    id: ToppingIds.ELECTRIC_VEHICLE_BATTERY_CHARGING,
    icon: 'assets/icons/electric-charge-station.svg',
    titleId: 'electric-vehicle-battery-charging-topping',
    descriptionId: 'electric-vehicle-battery-charging-topping-description',
    showStartingFrom: false,
  },
  'vehicle-battery-charging-topping': {
    id: ToppingIds.VEHICLE_BATTERY_CHARGING,
    icon: 'assets/icons/battery-charge.svg',
    titleId: 'vehicle-battery-charging-topping',
    descriptionId: 'vehicle-battery-charging-topping-description',
    showStartingFrom: false,
  },
  'checking-inflating-tires-topping': {
    id: ToppingIds.CHECKING_INFLATING_TYRES,
    icon: 'assets/icons/tyres.svg',
    titleId: 'checking-inflating-tires-topping',
    descriptionId: 'checking-inflating-tires-topping-description',
    showStartingFrom: false,
  },
  'sheet-metal-paint-repair-topping': {
    id: ToppingIds.SHEET_METAL_PAINT_REPAIR,
    icon: 'assets/icons/paint-repair.svg',
    titleId: 'sheet-metal-paint-repair-topping',
    descriptionId: 'sheet-metal-paint-repair-topping-description',
    showStartingFrom: false,
  },
};

export const washToppingDictionary: ToppingDictionary = {};
